/*
 * Bypasses angular security checker for the given html string.
 *
 * @unstable
 */

import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeSource',
  standalone: false,
})
export class SafeSource implements PipeTransform {
  readonly sanitizer = inject(DomSanitizer);

  public transform(styles: string | null): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(styles);
  }
}
